export default __webpack_public_path__ + "static/media/patricelli-center.91b77e6e.png";